import { render } from "./LoginHome.vue?vue&type=template&id=6b1aac45&ts=true"
import script from "./LoginHome.vue?vue&type=script&lang=ts"
export * from "./LoginHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__